import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import HeaderWrapper from "../../Header/HeaderWrapper";
import TextMainBannerWrapper from "../../TextMainBanners/TextMainBannerWrapper";
import Spinner from "../../Spinner";
import { SendPostRequest } from "../../../http";
import FooterWrapper from "../../Footer/FooterWrapper";

function GridCardNews() {
  const [newsData, setNewsData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getNewsData();
    window.scrollTo(0, 0);
  }, []);

  const getNewsData = async () => {
    setLoading(true);
    try {
      const response = await SendPostRequest("news/list");
      setNewsData(response?.data);
    } catch (error) {
      console.error("Error fetching news:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-wrapper-inner">
      <div className="page-wrapper-inner">
        <HeaderWrapper />
        <TextMainBannerWrapper Heading="News and Updates" Image="theme-2-banner-news.webp" />

        <div className="container">

          {loading ? (
            <div className="d-flex justify-content-center py-5">
              <Spinner />
            </div>
          ) : newsData?.length > 0 ? (
            <div
              className="portfolio-section py-5"
            >
              <div className="row portfolio-wrap portfolio-classic px-4" data-animation="fadeInDown">
                {newsData.map((item, index) => (
                  <div
                    key={index}
                    className="portfolio-item portfolio-overlay-wrap home-news-grid-card col-lg-4 col-md-4 col-sm-4 col-xs-6"
                  >
                    <div className="portfolio-thumb home-news-portfolio-thumb relative cleangrid-services-mobile-view">
                      <Link
                        to={`/news/detail/${item.slug}`}
                        rel="noopener noreferrer"
                      >
                        <img
                          src={item.image}
                          className="img-fluid"
                          alt={item.title}
                        />
                      </Link>
                      <div className="portfolio-wrap">
                        <div className="portfolio-details-overlay">
                          <Link
                            to={`/news/detail/${item.slug}`}
                            rel="noopener noreferrer"
                          >
                            <h3 className="mb-3 grid-card-home-news">
                              {item.title}
                            </h3>
                          </Link>
                          <div className="portfolio-icons">
                            <Link
                              to={`/news/detail/${item.slug}`}
                              className="link-icon"
                              rel="noopener noreferrer"
                            >
                              <i className="icon-link text-white"></i>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div className="col-12 text-center my-5 py-5">
              <h4>No Record Available</h4>
            </div>
          )}

        </div>


        <FooterWrapper />
      </div>
    </div>
  );
}

export default GridCardNews;